/**
 * Business route segment → team role permission key (production Xs guard).
 * null = any authenticated user; omit = authenticated only (no extra check).
 */
export const ROUTE_PERMISSIONS = {
  dashboard: "Dashboard_Read",
  livechat: "LiveChat_Read",
  history: "History_Read",
  sendtestmessage: "Sendtestmessage_Read",
  contacts: "Contacts_Read",
  archivedcontacts: "ArchivedContacts_Read",
  fetchingallcampaign: "Campaign_Read",
  broadcastCampaign: "Campaign_Create_Broadcast_Campaign",
  campaign: "Campaign_Create_CSV_Broadcast_Campaign",
  apicampaign: "Campaign_Create_Api_Campaign",
  "whatsapp+sms_campaign": "Campaign_Create_Whatspp+SMS_Campaign",
  campaignv2: "Campaign_Create_Whatspp+SMS_Campaign",
  fetchalltemplates: "whatsAppTemplate_Read",
  createtemplate: "whatsAppTemplate_Create",
  allsmstemplate: "SmsTemplate_Read",
  templatelib: "Template_Lib_Read",
  whatsappform: "SmsTemplate_Read",
  chatbot: "SmsTemplate_Read",
  chatbotai: "SmsTemplate_Read",
  whatsappflow: "SmsTemplate_Read",
  fetchallcannedmessage: "CannedMessage_Read",
  "create-canned-message": "CannedMessage_Create",
  attribute: "Attribute_Read",
  fetchalltags: "Tag_Read",
  createtag: "Tag_Create",
  allteams: "Team_Read",
  "create-teams": "Team_Create",
  teamroles: "Teamrole_Read",
  "create-teamsrole": "Teamrole_Create",
  livechatsettings: "GreetingMessage_Read",
  "optin-outmanagement": "Opt-inManagement_Read",
  flows: null,
  dialogflowcredentials: "Dialogflow_Read",
  myprofile: "Profile_Read",
  changepassword: "Profile_Change_Password",
  apikeygenerate: "APIKey_Read",
  waba_analytics: "WabaAnalytics_Read",
  agentactivity: "AgentActivity_Read",
  webhookSubscribe: "Webhook_Read",
  "whatsapp-widget-button": null,
  smsconfig: "SMSConfig_Read",
  googlesheetintegration: "GoogleSheetIntegration_Read",
  googleformconfig: "GoogleFormConfig_Read",
  googleoauthcallback: null,
  plans: "Plans_Read",
  payments: "Payments_Read",
  paymentsetup: "PaymentsSetup_Read",
};

export const getRouteSegment = (pathname) => {
  const parts = String(pathname || "").split("/").filter(Boolean);
  const idx = parts.findIndex((part) => part.toLowerCase() === "businessprojects");
  if (idx >= 0 && parts[idx + 2]) return parts[idx + 2];
  return parts[parts.length - 1] || "";
};

export const getProjectIdFromPath = (pathname) => {
  const parts = String(pathname || "").split("/").filter(Boolean);
  const idx = parts.findIndex((part) => part.toLowerCase() === "businessprojects");
  if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
  return "";
};

export const getRequiredPermission = (pathname) => {
  const segment = String(getRouteSegment(pathname) || "").trim();
  if (!segment) return undefined;
  if (Object.prototype.hasOwnProperty.call(ROUTE_PERMISSIONS, segment)) {
    return ROUTE_PERMISSIONS[segment];
  }
  const match = Object.keys(ROUTE_PERMISSIONS).find(
    (key) => key.toLowerCase() === segment.toLowerCase(),
  );
  return match ? ROUTE_PERMISSIONS[match] : undefined;
};
